const GroupMsgReplyStatistics = () =>
  import(
    '@/views/main/wechatMgmt/groupMsgReplyStatistics/GroupMsgReplyStatistics.vue'
  )
export default {
  path: '/main/wechatMgmt/groupMsgReplyStatistics',
  name: 'groupMsgReplyStatistics',
  component: GroupMsgReplyStatistics
}
